import { type OpenAPIV3_1 } from 'openapi-types';
import { OpenAPISchema } from './OpenAPISchema';
import { type SchemaObjectWithName } from './types';
import {
  extractContentType,
  getSchemaProperties,
  getFieldIsRequired
} from './utils/openapi';

export const Schema = ({
  input,
  title
}: {
  input: OpenAPIV3_1.ResponseObject | OpenAPIV3_1.RequestBodyObject | undefined;
  title: string;
}) => {
  const extracted = extractContentType(input);

  if (!extracted) return null;

  const { contentType, schema, isRequired } = extracted;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <div className="text-2xl">{title}</div>
        <div className="w-2/3 border-b border-gray-300"></div>
      </div>

      {(contentType === 'text/csv' || contentType === 'text/plain') &&
        schema && (
          <OpenAPISchema
            key="content/type"
            field={schema as SchemaObjectWithName}
          />
        )}

      {contentType === 'application/json' && schema && (
        <div className="flex flex-col gap-4">
          {Object.entries(getSchemaProperties(schema) || {}).map(
            ([key, field]) => (
              <OpenAPISchema
                key={key}
                field={
                  {
                    name: key,
                    customRequired:
                      getFieldIsRequired(schema, key) ?? isRequired,
                    ...field
                  } as SchemaObjectWithName
                }
              />
            )
          )}
        </div>
      )}
    </div>
  );
};
